import Service from "../Service";
const resource = "HmnPositionDocument/";

export default {

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: {
                PstID: dtr.filter ? dtr.filter.PstID : null,
                requestID: requestID
            },
        });
    },

    save(document, requestID, PstIDsCSV = null) {
        return Service.post(resource + "save", document, {
            params: { requestID: requestID, PstIDsCSV: PstIDsCSV },
        });
    },

    getByPosition(pstId, requestID, agtId = null) {
        return Service.get(resource + "byPosition", {
            params: { pstId: pstId, requestID: requestID, agtId: agtId },
        });
    },

};
